var map = {
	"./alflorex_packshot-1.png": "97b4",
	"./alflorex_packshot-2.png": "45aa",
	"./diagnostico/algoritmo_desktop.svg": "8eb5",
	"./diagnostico/algoritmo_desktop_oculto.svg": "ed9f",
	"./diagnostico/algoritmo_desktop_oculto_bacterias.svg": "add6",
	"./diagnostico/algoritmo_mobile.svg": "14c6",
	"./diagnostico/algoritmo_mobile_oculto.svg": "c5de",
	"./diagnostico/algoritmo_mobile_oculto_bacterias.svg": "6b29",
	"./sindrome/sindrome_causas.jpg": "7e4e",
	"./sindrome/sindrome_classificacao.jpg": "7059",
	"./sindrome/sindrome_fatores_risco.jpg": "978c",
	"./sindrome/sindrome_o_que_e.jpg": "c17a",
	"./sindrome/sindrome_sinais_sintomas.jpg": "dde5",
	"./tratamento/tratamento_alflorex.jpg": "10d6",
	"./tratamento/tratamento_dieta.jpg": "7618",
	"./tratamento/tratamento_gestao_stress.jpg": "d6d8",
	"./tratamento/tratamento_lifestyle.jpg": "6bfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";